export default __webpack_public_path__ + "static/media/n3.a99df92d.png";